// extracted by mini-css-extract-plugin
export default {"siteFooter":"footer_styles_siteFooter__Tr3m1","copyRight":"footer_styles_copyRight__5MpSK","footerLinksWrapper":"footer_styles_footerLinksWrapper__OSRPQ"};